import { render } from "./SCR010.vue?vue&type=template&id=c3c52c24"
import script from "./SCR010.vue?vue&type=script&lang=ts"
export * from "./SCR010.vue?vue&type=script&lang=ts"
script.render = render

export default script